__turbopack_context__.v({
  "buttons": "NotFound-module-scss-module__7xHgJW__buttons",
  "heading": "NotFound-module-scss-module__7xHgJW__heading",
  "main": "NotFound-module-scss-module__7xHgJW__main",
});
